module.exports = __webpack_public_path__ + "img/9-7.39665538.jpg";